import { Avatar, Box, Typography } from "@mui/material";
import { styles } from "./stylesReactionsModal";
import HeartSvg from "@/assets/svg/HeartSvg";
import LightningSvg from "@/assets/svg/LightningSvg";
import { useNavigate } from "react-router-dom";

interface ReactionItemProps {
  type: "like" | "zap";
  username: string;
  time: string;
  amount?: string;
  // amountUsd?: string;
  comment?: string;
  avatar?: string | null;
  uid: string;
}

const ReactionItem: React.FC<ReactionItemProps> = ({
  type,
  username,
  time,
  amount,
  // amountUsd,
  comment,
  avatar,
  uid,
}) => {
  const navigate = useNavigate();
  return (
    <Box sx={styles.reactionItem} onClick={() => navigate(`/profile/${uid}`)}>
      <Avatar src={avatar || undefined} sx={styles.reactionAvatar} />

      <Box sx={styles.reactionUserBlock}>
        <Box sx={styles.reactionUserRow}>
          <Typography sx={styles.reactionUsername}>{username}</Typography>
          <Typography sx={styles.reactionTime}> • {time}.</Typography>
        </Box>

        {type === "zap" && comment && (
          <Typography sx={styles.reactionComment}>{comment}</Typography>
        )}
      </Box>

      <Box sx={styles.reactionAmountBox}>
        <Box sx={styles.reactionIcon}>{type === "like" ? <HeartSvg /> : <LightningSvg />}</Box>

        <Box sx={styles.reactionAmountValueBlock}>
          <Typography sx={styles.reactionAmount}>{amount}</Typography>
          {/* <Typography sx={styles.reactionAmountUsd}>{amountUsd}</Typography> */}
        </Box>
      </Box>
    </Box>
  );
};

export default ReactionItem;
